/**
 * 3D Cursor — Blender-style first-class scene helper.
 *
 * The 3D cursor is a world-space point with a selection flag. It is
 * consulted as a pivot option, as the default spawn position for newly
 * added objects, and as a universal snap source/target.
 *
 * The `selected` flag is transient UI state and is intentionally NOT
 * serialized. Position round-trips with the scene document.
 *
 * Selection is mutually exclusive with object / edit / pose selection —
 * this invariant is enforced in the store, not here. This module stays
 * pure (no store, no THREE) so it can be consumed safely from workers,
 * persistence, and tests.
 */

export interface Cursor3DState {
  /** World-space position. */
  position: [number, number, number];
  /** Selected = TransformGizmo targets the cursor instead of object/bone/vertex. */
  selected: boolean;
}

export const DEFAULT_CURSOR_3D: Cursor3DState = {
  position: [0, 0, 0],
  selected: false,
};

/** Resolve the spawn position for a newly-added object (at the cursor). */
export function cursorSpawnPosition(
  cursor: Cursor3DState,
): [number, number, number] {
  return [cursor.position[0], cursor.position[1], cursor.position[2]];
}
